<template>
    <Header />
    <UMain>
        <UContainer>
            <slot />
        </UContainer>
    </UMain>
    <UFooter />
</template>
